import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconActivity, IconSettings } from '@tabler/icons-react';
import { lazy } from 'react';

/**
 * Бутстрап платформенного модуля Core (клиентская часть).
 */
export async function setup(app: AppRuntime): Promise<void> {
  const core = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  core.useNavigation([
    {
      icon: IconSettings,
      label: 'Системные опции',
      url: '/core/options',
      component: lazy(() => import('./components/OptionsList')),
    },
    {
      icon: IconActivity,
      label: 'Системный монитор',
      url: '/core/monitor',
      component: lazy(() =>
        import('./components/SystemMonitor/SystemMonitorDashboard').then(m => ({
          default: m.SystemMonitorDashboard,
        }))
      ),
    },
  ]);
}
